export default __webpack_public_path__ + "static/media/mind.227a8ea9.svg";